import { useAuth } from "@/context/auth-context";
import { verifyAccountSetupAllowsMainAppAccess } from "@/pages/SignUp/verifyAccountSteps";
import { Navigate, Outlet } from "@tanstack/react-router";

function UserAccountSetupGuard() {
	const { user } = useAuth();

	const hasCompletedIdentityVerification =
		verifyAccountSetupAllowsMainAppAccess(user);

	if (hasCompletedIdentityVerification) {
		return <Outlet />;
	}

	return (
		<Navigate
			to="/sign_up/verify-account"
			search={{
				intent: "returning",
			}}
		/>
	);
}

export default UserAccountSetupGuard;
